import { createElement as h } from "react"

import {
  Divider,
  ListItemText as ItemText,
  ListItem,
  ListItemIcon,
  List as ListRoot,
  ListSubheader as Subheader,
} from "@mui/material"
import { makeStyles } from "@mui/styles"
import T from "prop-types"

import { Data } from "@cirrus/fe-lib"

const useIconOverrides = makeStyles({
  root: {
    minWidth: 42,
  },
})

export { Divider, ItemText, Subheader }

export const Root = ({ children, content, mapper, ...props }) =>
  h(ListRoot, props, mapper ? Data.indexedMap(mapper, content) : content, children)

Root.propTypes = {
  children: T.oneOfType([T.arrayOf(T.node), T.node]),
  content: T.oneOfType([T.array, T.node]),
  mapper: T.func,
}

export const ItemIcon = (props) =>
  h(ListItemIcon, Data.merged(props, { classes: useIconOverrides() }))

export const Item = ({ AdornmentProps, ContentProps, adornment, children, content, ...props }) =>
  h(
    ListItem,
    props,
    adornment && h(ItemIcon, AdornmentProps, adornment),
    content && h(ItemText, Data.merged(ContentProps, { primary: content })),
    children,
  )

Item.propTypes = {
  AdornmentProps: T.object,
  ContentProps: T.object,
  adornment: T.node,
  children: T.oneOfType([T.arrayOf(T.node), T.node]),
  content: T.node,
}
